import { render, staticRenderFns } from "./guCi.vue?vue&type=template&id=64f6ec37&scoped=true&"
import script from "./guCi.vue?vue&type=script&lang=js&"
export * from "./guCi.vue?vue&type=script&lang=js&"
import style0 from "./guCi.vue?vue&type=style&index=0&id=64f6ec37&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f6ec37",
  null
  
)

export default component.exports